import { updateBackTrace } from "@/services/summary";
import {
  BackTraceKeyMap,
  meetingContentFormatPattern,
  SummaryBackTraceArr,
} from "@/constants/record";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { BackTraceType, IBackTrace, ISummary } from "@/types/summary";

export const updateTodoBackTraceId = (
  newSummary: ISummary["completeAiGcContent"]
) => {
  const newBackTraceIds = summaryCommonStore.getState().newBackTraceIds;
  let newSummaryContentIds: null | string[];
  ["todo"].forEach((summaryType) => {
    const formatSummaryType = summaryType as "todo";
    const backTraceKey = BackTraceKeyMap[formatSummaryType] as BackTraceType;
    if (!backTraceKey) return;
    newSummaryContentIds = newBackTraceIds[backTraceKey];
    newSummary[formatSummaryType].forEach((item: string, index: number) => {
      if (!item && newSummaryContentIds) {
        newSummaryContentIds[index] = "";
      }
    });
    const formatNewSummaryContentIds = newSummaryContentIds.filter(
      (item) => item
    );
    summaryCommonStore
      .getState()
      .setNewBackTraceIds(backTraceKey, formatNewSummaryContentIds);
  });
};

export const updateTodoBackTrace = async (streamName: string) => {
  const newSummaryContentIds = summaryCommonStore.getState().newBackTraceIds;
  const originBackTraceData = summaryCommonStore.getState().originBackTraceData;
  ["todoBackTrace"].forEach(async (backTrace) => {
    const oldBackTrace = originBackTraceData[backTrace as BackTraceType];
    const newBackTrace: IBackTrace = {};
    for (const oldContentId in oldBackTrace) {
      // 旧坐标替换为新坐标
      const newContentId =
        newSummaryContentIds[backTrace as BackTraceType].indexOf(oldContentId);
      if (newContentId > -1) {
        newBackTrace[newContentId] = oldBackTrace[oldContentId];
      }
    }
    console.log("updateBackTrace", backTrace, oldBackTrace, newBackTrace);
    const meetingEventType = SummaryBackTraceArr[backTrace];
    await updateBackTrace(streamName, meetingEventType, newBackTrace);
  });
};

export const formatTodo = (
  formatNewSummary: ISummary["completeAiGcContent"]
) => {
  const formatSummaryType = "todo";
  formatNewSummary[formatSummaryType] = formatNewSummary[formatSummaryType]
    .filter((item: string) => {
      const flag = !!item;
      return flag;
    })
    .map((item: string, index: number) => {
      const [formatItem, ...speakerList] = item.split("@");
      const formatSpeakerList = speakerList.filter((item) => item).join("@");
      // 兜底措施，确认旧序号已经去除
      const content = formatItem.replace(meetingContentFormatPattern, "");
      // 重新设置序号，否则大模型无法识别可回溯点
      return `${index + 1}.${content}${
        formatSpeakerList ? `@${formatSpeakerList}` : ""
      }`;
    });
  return formatNewSummary;
};

export const updateContentBackTrace = async (streamName: string) => {
  const newSummary = summaryStore.getState().newSummary;
  if (!newSummary) {
    return;
  }
  const formatNewSummary = formatContent({ ...newSummary });

  const formatSummaryType = "content";
  const currentBackTraceDataKeyArr = formatNewSummary[formatSummaryType];
  // 比较 originBackTraceDataArr 和 currentBackTraceDataKeyArr
  const originBackTraceDataKeyArr =
    summaryStore.getState().summary?.srcAiGcContent?.content;
  // 对应的id是0，1，3，4
  if (!originBackTraceDataKeyArr) return;
  const backTrace = "contentBackTrace";

  const originBackTraceData = summaryCommonStore.getState().originBackTraceData;
  const oldBackTrace = originBackTraceData[backTrace as BackTraceType] || {};

  const formatOriginBackTraceDataKeyArr = originBackTraceDataKeyArr.filter((_item, index)=>{
    return Object.keys(oldBackTrace).includes(index.toString())
  });
  console.log('updateContentBackTrace', originBackTraceDataKeyArr, formatOriginBackTraceDataKeyArr, currentBackTraceDataKeyArr);

  const matches = findBestMatch(
    formatOriginBackTraceDataKeyArr,
    currentBackTraceDataKeyArr
  );
  const formatMatches = matches.map((match) => {
    return {
      ...match,
      matchIndex: match.matchDegree >= 0.5 ? match.matchIndex : -1,
    };
  });
  console.log('formatMatches', formatMatches);
  const newBackTrace: IBackTrace = {};
  if(formatMatches.length === 0) return;

  Object.keys(oldBackTrace).forEach((oldContentId, index) => {
    const newContentId = formatMatches[index]?.matchIndex;
    // 旧坐标替换为新坐标
    if (newContentId > -1) {
      newBackTrace[newContentId] = oldBackTrace[oldContentId];
    }
  });

  console.log("updateBackTrace", backTrace, oldBackTrace, newBackTrace);
  const meetingEventType = SummaryBackTraceArr[backTrace];
  await updateBackTrace(streamName, meetingEventType, newBackTrace);

};

export const formatContent = (
  formatNewSummary: ISummary["completeAiGcContent"]
) => {
  const formatSummaryType = "content";
  formatNewSummary[formatSummaryType] = formatNewSummary[
    formatSummaryType
  ].filter((item: string) => {
    const flag = !!item;
    return flag;
  });
  return formatNewSummary;
};

function findBestMatch(
  originBackTraceDataKeyArr: string[],
  currentBackTraceDataKeyArr: string[]
): { matchIndex: number; matchDegree: number }[] {
  return originBackTraceDataKeyArr.map((originStr) => {
    let bestMatchIndex = -1;
    let bestMatchDegree = 0;

    currentBackTraceDataKeyArr.forEach((currentStr, index) => {
      // Check for exact match first
      if (originStr === currentStr) {
        bestMatchIndex = index;
        bestMatchDegree = 1;
        return;
      }

      // Calculate matching degree
      let matchingChars = 0;
      const originChars = originStr.split("");

      // Count matching characters
      originChars.forEach((char) => {
        if (currentStr.includes(char)) {
          matchingChars++;
        }
      });

      const matchDegree = matchingChars / originStr.length;

      // Update best match if current match is better
      if (matchDegree > bestMatchDegree) {
        bestMatchDegree = matchDegree;
        bestMatchIndex = index;
      }
    });

    return {
      matchIndex: bestMatchIndex,
      matchDegree: bestMatchDegree,
    };
  });
}

// Example usage:
// const originArr = ["你好世界", "测试文本"];
// const currentArr = ["你好地球", "测试样例", "文本测试"];

// const matches = findBestMatch(originArr, currentArr);
// console.log(matches);
// Output example:
// [
//   { matchIndex: 0, matchDegree: 0.75 },  // "你好世界" best matches with "你好地球"
//   { matchIndex: 1, matchDegree: 0.5 }    // "测试文本" best matches with "测试样例"
// ]

